export default "__VITE_ASSET__DnMnBKwF__"